<template>
  <div style="margin-top:-10px !important">
    <b-row class="px-pad border-bottom" style="height:42px">
      <b-col md="6" lg="6" sm="6" cols="6" class="px-0">
        <span class="fw-semi-bold index-heading pl-0">Opening Balance</span>
      </b-col>

      <b-col md="6" lg="6" sm="6" cols="6" class="text-right px-0">
        <b-button
          variant="primary"
          :to="{name:'OpeningBalanceImport'}"
          size="sm"
        >Import Opening Balance</b-button>
      </b-col>
    </b-row>
    <b-row class="px-pad">
      <b-col cols="12" class="px-0">
        <div class="mt-3">
          Migration Date: {{getDateFormat(org_details.migration_date)}}
          <i
            class="la la-edit la-lg text-link mb-3 ml-2 cursor_pointer"
            v-b-modal.migrationdate
          ></i>
        </div>
      </b-col>
    </b-row>
    <b-row class="px-0">
      <b-col cols="12" class="px-0">
        <div class="obdetails pt-3">
          <div class="head-section text-uppercase fw-semi-bold">
            <div class="row">
              <div class="col-lg-8 px-5">Accounts</div>
              <div class="col-lg-2 text-right px-5">Debit ({{orgCurrency}})</div>
              <div class="col-lg-2 text-right px-5">Credit ({{orgCurrency}})</div>
            </div>
          </div>

          <div
            class="account-group"
            v-for="item in list"
            :key="item.id"
            v-if="item.account_type!='accounts_payable'&&item.account_type!='inventory_asset'"
          >
            <div class="row account-type pb-0">
              <div class="col-lg-8 px-5">
                <router-link :to="{name:'OpeningBalanceType',params:{type:item.account_type}}">
                  <p class="align-top fw-semi-bold mb-1">
                    <i class="la la-credit-card la-lg pr-2 text-dark"></i>
                    {{ item.account_type_formatted }}
                  </p>
                </router-link>
              </div>
              <div
                class="col-lg-2 text-right px-5"
              >{{ item.debit_or_credit == 'DEBIT' ? item.bcy_amount: '0.00'}}</div>
              <div
                class="col-lg-2 text-right px-5"
              >{{ item.debit_or_credit == 'CREDIT' ? item.bcy_amount : '0.00'}}</div>
            </div>
          </div>
          <!-- <div class="total-section bg-light">
            <div class="row">
              <div class="offset-lg-6 col-lg-2 fw-semi-bold">TOTAL :</div>
              <div
                class="col-lg-2 text-right fw-semi-bold px-5"
              >{{ Number(total.debit).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</div>
              <div
                class="col-lg-2 text-right fw-semi-bold px-5"
              >{{ Number(total.credit).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</div>
            </div>
          </div> -->
        </div>
      </b-col>
    </b-row>
    <b-modal
      id="migrationdate"
      size="sm"
      ref="migrationdate"
      body-class="bg-white"
      cancel-title="cancel"
      cancel-variant="light"
      :ok-title-html="modalsubmit==true?loaderIcon+'yes':'yes'"
      :ok-disabled="modalsubmit"
      title="Migration Date"
      v-model="migrationmodel"
      @ok.prevent="handlemigrationdate"
      @shown="migration_date =org_details.migration_date,error_show=false"
    >
      <b-row>
        <b-col xl="12" lg="12" md="12" xs="12" sm="12">
          <b-alert class="alert-transparent alert-danger" :show="error_show">
            <p>Migration date should not be empty</p>
          </b-alert>
        </b-col>
      </b-row>
      <DatePicker
        @input="selectDate($event)"
        :format="$AppDetails.organization.date_format"
        style="width:100% !important;"
        lang="en"
        name="migration_date"
        v-model="migration_date"
      >
        <i class="fa fa-calendar" slot="calendar-icon" />
      </DatePicker>
    </b-modal>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import { notificationMixin } from "@/mixins/notification";
import DatePicker from "vue2-datepicker"; // vue datepicker
import { formatDate } from "@/mixins/formatDate"; // global fucntion for calling notification
export default {
  mixins: [formatDate, notificationMixin],
  components: {
    DatePicker,
  },
  data() {
    return {
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center",
      migrationmodel: false,
      modalsubmit: false,
      error_show: false,
      migration_date: "",
      loaderIcon: `<i class="fa fa-circle-o-notch fa-spin mr-2"></i>`,
    };
  },
  created() {
    this.initializationMessengerCode();
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air",
    };
  },
  methods: {
    handlemigrationdate() {
      if (!this.migration_date) {
        this.error_show = true;
      } else {
        this.$store
          .dispatch(
            "general/updatemigrationdate",
            JSON.stringify({
              migration_date: this.migration_date,
            })
          )
          .then((result) => {
            if (result.status == 200) {
              this.Orgmigrationdate = this.migration_date;
              this.error_show = false;
              this.migrationmodel = false;
            }
            window.Messenger().post({
              extraClasses:
                "messenger-fixed messenger-on-top messenger-on-center",
              message: result.data.status,
              type: result.status == "200" ? "success" : "danger",
              showCloseButton: true,
            });
          });
      }
    },
    selectDate(val) {
      var value =
        val == "" || typeof val == "undefined" || val == null
          ? ""
          : this.formatDate(val);
      this.migration_date = value;
    },
  },
  computed: {
    total() {
      var debit = parseFloat(0.0),
        credit = parseFloat(0.0);
      for (var i = 0; i < this.list.length; i++) {
        var amount = this.list[i].bcy_amount;
        amount = amount.replace(/,/g, "");

        if (this.list[i].debit_or_credit == "DEBIT") {
          debit += parseFloat(amount);
        } else {
          credit += parseFloat(amount);
        }
      }
      return {
        debit: debit,
        credit: credit,
      };
    },
    ...mapState({
      list: (state) => state.settings.list,
    }),
    ...mapGetters(["orgCurrency", "org_details"]),
    Orgmigrationdate: {
      get() {
        return this.$store.state.permission.org_details.migration_date;
      },
      set(val) {
        this.$store.state.permission.org_details.migration_date = val;
      },
    },
  },
};
</script>
<style scoped>
.obdetails .head-section {
  padding: 10px 0;
  font-size: 12px;
}
.obdetails .account-group {
  border-top: 1px solid #eaecf2;
  padding-bottom: 10px;
}
.obdetails .account-group .account-type,
.obdetails .account-group .accounts {
  padding: 10px 0;
}
.obdetails .total-section {
  padding: 10px 10px;
  margin: 0 -10px;
}
</style>